/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ChatHistory = ({ chatThreads }) => {
    return (
        <div>
            <h2>Chat History</h2>
            {chatThreads.length > 0 ? (
                <ul>
                    {chatThreads.map((chat) => (
                        <li key={chat._id}>
                            <strong>{chat.title}</strong>
                            {chat.messages.map((msg, idx) => (
                                <div key={idx}>
                                    <strong>{msg.role}: </strong>{msg.content}
                                </div>
                            ))}
                        </li>
                    ))}
                </ul>
            ) : (
                <p>No chat history available.</p>
            )}
        </div>
    );
};

export default ChatHistory;
